import { type ExternalFile } from '@/lib/types';
import getGoogleDriveFilePublicUrl from '../UploadWithGoogleDrive/uploadFileToGoogleDrive/getGoogleDriveFilePublicUrl';
import * as Sentry from '@sentry/react';

const makeGoogleDriveExternalFilesPublic = async (
  externalFiles: ExternalFile[],
): Promise<ExternalFile[]> => {
  const publicExternalFiles = await Promise.all(
    externalFiles.map(
      async (externalFile: ExternalFile): Promise<ExternalFile> => {
        try {
          const publicUrl = await getGoogleDriveFilePublicUrl(
            externalFile.externalId,
          );

          return {
            ...externalFile,
            url: publicUrl,
          };
        } catch (error) {
          // no-op: we likely don't have sufficient permissions to get a public
          // URL. Still, we want to keep an eye on these errors for now.
          Sentry.captureException(error);

          return externalFile;
        }
      },
    ),
  );

  return publicExternalFiles;
};

export default makeGoogleDriveExternalFilesPublic;
